import { Fragment } from "react";

import Grid from "@mui/material/Grid";

import {
    useCompanyLevelContent,
    useStyles
} from "components/CompanyLevel/hooks";
import CompanyLevelBodyItem from "components/CompanyLevel/shared/components/CompanyLevelBodyItem";
import { COMPANY_LEVELS } from "shared";

const CompanyLevelDesktopBody = () => {
    const { companyLevelBodyRows, getIndexInfo } = useCompanyLevelContent();
    const { getGridItemCSS, getCompanyLevelDesktopCSS } = useStyles();

    return (
        <>
            {companyLevelBodyRows.map(item => (
                <Fragment key={item.info}>
                    {Object.values(COMPANY_LEVELS).map((entry, index) => {
                        const { isFirst, isLast, entryLevel } = getIndexInfo(
                            index,
                            item
                        );

                        return (
                            <Grid
                                key={`${entry}_body`}
                                size={{ xs0: 3, md: 3, lg: 3 }}
                                css={getGridItemCSS(isLast, false, isFirst)}
                            >
                                <CompanyLevelBodyItem
                                    companyLevel={entryLevel}
                                    itemCSS={getCompanyLevelDesktopCSS(
                                        item.params,
                                        isLast,
                                        isFirst
                                    )}
                                    tooltipText={
                                        isFirst ? item.infoTooltip : undefined
                                    }
                                />
                            </Grid>
                        );
                    })}
                </Fragment>
            ))}
        </>
    );
};

export default CompanyLevelDesktopBody;
